import {
    HierarchyProcessingStatus,
    IExportHierarchyResponse,
    IGetNodeWbIdByLKNodeResponse, IHierarchyBuilderOperationStartOptions, IHierarchyBuilderOperationStatus,
    IHierarchyService,
    INodeLogicalKey
} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from "axios";


export interface IHierarchyServiceRequest {
    requestType:       string,
    wbHierarchyId?:    number,
    wbMasterDataSetId?: number,
    entityDimension?:  string,
    logicalKey?:       INodeLogicalKey,
    options?:          any
}

export interface IHierarchyServiceResponse {
    request: IHierarchyServiceRequest,
    bSuccess: boolean,
    sErrors: string[],
    sWarnings: string[],
    results: any
}

export class HierarchyService
    implements IHierarchyService
{
    constructor() {}

    static requestCount = Math.floor(Math.random() * 100000)

    async getNodeWbIdByLKNode(wbMasterDataSetId: number, entityDimension: string, logicalKey: INodeLogicalKey): Promise<IGetNodeWbIdByLKNodeResponse> {

        return await HierarchyService.makeRequest({
            requestType: "getNodeWbIdByLKNode",
            wbMasterDataSetId: wbMasterDataSetId,
            entityDimension: entityDimension,
            logicalKey: logicalKey
        })
    }

    async getHierarchyProcessingStatus(wbHierarchyId: number): Promise<IHierarchyBuilderOperationStatus> {
        return await HierarchyService.makeRequest({
            requestType: "getHierarchyProcessingStatus",
            wbHierarchyId: wbHierarchyId
        })
    }

    async startHierarchyProcessing(wbHierarchyId: number, options: IHierarchyBuilderOperationStartOptions): Promise<void> {
        return await HierarchyService.makeRequest({
            requestType: "startHierarchyProcessing",
            wbHierarchyId: wbHierarchyId,
            options : options || {}
        })
    }

    async exportHierarchy(wbHierarchyId: number, maintenancePeriod: number, options: { [key: string]: any }): Promise<IExportHierarchyResponse> {
        const exportRequest: IHierarchyServiceRequest = {
            requestType: "exportHierarchy",
            wbHierarchyId: wbHierarchyId,
            options: {
                ...options,
                maintenancePeriod: maintenancePeriod,
            }
        }
        return HierarchyService.makeRequest(exportRequest)
    }

    //
    private static async makeRequest(hierarchyRequest: IHierarchyServiceRequest)
        : Promise<any>
    {

        try {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'hierarchy';
            else
                sEndPoint += '/hierarchy';

            let resp = await axios.post(sEndPoint, {
                data: {request: hierarchyRequest,
                       requestCacheBuster: HierarchyService.requestCount++}})

            let responseData: IHierarchyServiceResponse = resp.data;
            if ('request' in responseData) {
                if (!responseData.bSuccess) {
                    throw new Error("Hierarchy Service Response: " + (responseData.sErrors || ['Unknown']).toString())
                } else {
                    return responseData.results
                }
            }

            throw new Error('Unable to parse Hierarchy Web Response: ' + responseData);

        } catch (err: any) {
            throw new Error('Unable to obtain Hierarchy Results from Server. ' + err);
        }
    }


}